import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { AccountingActionEnum } from "./accounting-action-enum";

/**
 * Allowed COA types for actions when used at the supplier (Akun Pembelian)
 * context.
 */
export const SupplierAccountingActionAllowedTypes = Object.freeze({
  [AccountingActionEnum.ACCOUNTS_PAYABLE]: [
    ChartOfAccountTypeEnum.ACCOUNTS_PAYABLE,
  ],
  [AccountingActionEnum.PURCHASE_DOWN_PAYMENT]: [
    ChartOfAccountTypeEnum.ACCOUNTS_RECEIVABLE,
  ],
});
